import axios from 'axios';
import { timeIntervalToStartDate } from '../util';

export default class MavenAnalytics {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getAnalytics(brandId, interval, type) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/services/?interval=${interval}&type=${type}`);
    return result.data[type];
  }

  async getInternalAnalytics(brandId, interval) {
    const startDateFn = timeIntervalToStartDate[interval];
    if (!startDateFn) {
      throw new Error(`Unrecognized interval for internal analytics: ${interval}`);
    }

    return axios.get(`${this.baseURL}/account/${brandId}/internal/dynamic-routing?startDate=${startDateFn()}`);
  }
}
